import { ReactComponent as GlobeIcon } from '~/ui/assets/images/global.svg';
import variables from '~/ui/assets/styles/colors.module.scss';
import { ReactElement } from 'react';

import hasGlobalUserRoleInClinic from '../../helpers/hasGlobalUserRoleInClinic';
import { AllocationRole } from '../../model/types';

import styles from './TeamMemberAccordion.module.scss';

interface IProps {
  roles: AllocationRole[] | undefined;
  clinicId: string;
}

const GlobalUserBadge = ({ roles, clinicId }: IProps): ReactElement | null => {
  if (!hasGlobalUserRoleInClinic(roles, clinicId)) {
    return null;
  }

  return (
    <div className={styles.absoluteIcon}>
      <GlobeIcon width={16} height={16} color={variables.colorGreenGlobal} />
    </div>
  );
};

export default GlobalUserBadge;
